export default "__VITE_PUBLIC_ASSET__2828617e__"